import { useAppDispatch, useAppSelector } from '@/Hook/hooks';
import { getScreenConfig } from '@/Redux/Ducks/entryFormSlice';
// import { SetTabComponent } from '@/Redux/Ducks/tabSlice';
import { lazy, useEffect } from 'react';

import { AlignUIRender } from './indexUI';

let countRender: any = {};

const EntryForm = (props: any) => {

  const dispatch = useAppDispatch();

  const { routeTo } = props.match.params;

  const module = routeTo.substr(0, 2);
  const processCode = routeTo.split("_")[0].toUpperCase();

  const activeTabKey = useAppSelector((state) => state.Tab.activeTabKey);
  const activeObjectId = useAppSelector((state) => state.EntryForm.activeObjectId);
  const isConfigLoaded = useAppSelector((state) => state.EntryForm.isConfigLoaded);
  const authTokenLoaded = useAppSelector((state) => !!state.User.authToken);

  useEffect(() => {
    // this will work when direct call from URL
    if (!activeTabKey && !activeObjectId && authTokenLoaded)
      dispatch(getScreenConfig({ processCode }));

    countRender[routeTo] ? countRender[routeTo]++ : countRender[routeTo] = 1;
    console.log(`%cRender Entry Form Component ${routeTo} ${countRender[routeTo]}`, "color:red;font-size: 20px;font-weight: bold;text-align: center");
  }, [routeTo, authTokenLoaded]);

  const ScreenComponent = lazy(() =>
    import(`@/Screen/EntryForm/${module}/${processCode}`).catch((ex) => {
      const errorMessage = "Error while opening screen";
      console.error(errorMessage, ex);

      return { default: () => <div>{errorMessage}</div> };
    })
  );

  return AlignUIRender({ props, ScreenComponent, objectId: activeObjectId, isConfigLoaded });
}

export default EntryForm;